module.exports = __webpack_public_path__ + "static/img/15.53e9aed0.png";